export function toGroupMetricsDocumentPath(path: string) {
  const lastSlashIndex = path.lastIndexOf('/');
  const documentId = path.slice(lastSlashIndex + 1);
  return `${path}/GroupMetrics/${documentId}`;
}
